<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">

                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                                <div style="min-height: 500px;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <app-card-skelton *ngIf="!loading"></app-card-skelton>



                                            <app-alert-card *ngIf="loading" [data]=obj [size]=2></app-alert-card>

                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <!-- <label for="comment">Description</label> -->
                                                <textarea maxlength="250" class="form-control" formControlName="text"
                                                    placeholder="Description" rows="5"
                                                    [ngClass]="{ 'is-invalid': submitted && f.text.errors }"></textarea>
                                                <div style="text-align: right;" class="margin-b">
                                                    <p style="margin-bottom: -1rem;" class="small error">
                                                        {{f.text.value?.length || 0}}/250</p>
                                                </div>
                                                <div *ngIf="submitted && f.text.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.text.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>



                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label class="btn-bs-file color btn btn-lg main-backgroundcolor">
                                                    Upload Image
                                                    <input type="file" (change)="uploadBanner($event)" />
                                                </label>
                                            </div>
                                           
                                        </div>
                                    </div>

                                    <div *ngIf="coverPhoto" class="row margin-b">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <div class="image-wrapper"
                                                style="width:'100%'; height:'150px'; border-radius: 0px;">
                                                <img [src]="renderImage(coverPhoto)" alt="Image" style="width: 100%; height:150px;">
                                            </div>
                                            </div>
                                        </div>

                                    </div>




                                    
                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <select class="form-control" formControlName="accessibility" id="sel1"
                                                [ngClass]="{ 'is-invalid': submitted && f.accessibility.errors }"
                                                >
                                                    <option value="">Select Visiblity</option>
                                                    <option *ngFor="let props of accessibility" [value]="props.value"
                                                   >
                                                        {{props.name}}
                                                    </option>

                                                </select>
                                                <div *ngIf="submitted && f.accessibility.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.accessibility.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <br>
                                <button type="submit"
                                    class="btn btn-lg btn-block main-backgroundcolor color">Post</button>
                            </form>
                        </div>
                    </div>
                </div>


            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>